/* Keep the complete Flowcart widget; allow the primary photograph to paint first. */
(function () {
  var source = document.currentScript && document.currentScript.dataset.moduleSrc;
  var started = false;
  function start() {
    if (started || !source) return;
    started = true;
    // The vendor modal and iframe require their companion stylesheet.
    // Load it after the hero paints, before mounting the full chat widget.
    var cssSource = source.replace(/lite-checkout-button\.js(?:\?.*)?$/, 'sukhiba-checkout-button.css');
    var style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = cssSource;
    function mount() {
      var script = document.createElement('script');
      script.type = 'module';
      script.src = source;
      document.head.appendChild(script);
    }
    style.addEventListener('load', mount, {once:true});
    document.head.appendChild(style);
  }
  function painted() { requestAnimationFrame(function () { requestAnimationFrame(start); }); }
  function ready() {
    if (!document.body.classList.contains('template-product')) { start(); return; }
    var hero = document.querySelector('img[data-main-image]');
    if (!hero || hero.complete) { painted(); return; }
    hero.addEventListener('load', painted, {once:true});
    hero.addEventListener('error', painted, {once:true});
    document.addEventListener('pointerdown', start, {once:true,passive:true});
    document.addEventListener('keydown', start, {once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
}());